import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import HomeIcon from "@mui/icons-material/Home";
import urlService from "../services/url";

export default function UrlShortener() {
  const { shortcode } = useParams<{ shortcode: string }>();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        if (!shortcode) {
          setError(true);
          setLoading(false);
          return;
        }

        const response = await urlService.redirectShortUrl(shortcode);

        // Handle the new JSON response format
        if (response.data && response.data.success && response.data.data?.redirect_url) {
          window.location.href = response.data.data.redirect_url;
        } else {
          setError(true);
          setLoading(false);
        }
      } catch (error: any) {
        // Handle error cases
        setError(true);
        setLoading(false);
      }
    };

    handleRedirect();
  }, [shortcode]);

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
        sx={{ bgcolor: "background.default" }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Redirecting...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={3}
        sx={{
          bgcolor: "background.default",
          px: 3,
          textAlign: "center",
        }}
      >
        <LinkOffIcon sx={{ fontSize: 80, color: "error.main" }} />
        <Stack spacing={2} alignItems="center">
          <Typography variant="h4" fontWeight="bold" color="text.primary">
            URL Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" maxWidth={400}>
            The shortened URL you're looking for doesn't exist or has expired.
          </Typography>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => (window.location.href = "/")}
            sx={{ mt: 2 }}
          >
            Go to Homepage
          </Button>
        </Stack>
      </Box>
    );
  }

  return null;
}
